//@see https://github.com/kaizenplatform/kaizen-offer-webclient/blob/c005f9617342ec7ef7ee53b79b0d6528a6004cd3/src/usecase/ListCandidateUsecase.ts
import { Client as BelfastClient } from '@kaizenplatform/belfast';

class KaizenFilesClient {
  private belfastClient: BelfastClient;

  constructor({ baseUrl }: { baseUrl: string }) {
    this.belfastClient = new BelfastClient({ endpoint: baseUrl });
  }

  public upload = async (file: File, bucketId: string, organizationId: string) => {
    return await this.belfastClient.uploadFile(file, bucketId, organizationId);
  };
}

export default KaizenFilesClient;
